export default "__VITE_ASSET__BwKE5uyd__"